import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { MarketSubscriptions } from '@sorare/marketplace/src/components/MarketSubscriptions';

export const MLBMarketSubscriptions = () => {
  return <MarketSubscriptions sport={Sport.BASEBALL} />;
};
